import '../assets/css/todolist.css';
import React, { useState, useEffect} from 'react';
import Loader from '../assets/img/loader.svg';
import Warning from '../assets/img/icon-warning.svg';
export const Todolist = (props) => {

const googleSpreadTodolist = 'https://sheets.googleapis.com/v4/spreadsheets/1AHxdpUey35g4TI4vfRIBGODHagiLBdUeZk7wueXmoQ0/values/A2:D?key=AIzaSyAGavQjafyO17-8l5wtn6-cPyLgJVtk_3I' // Si les champs sont ok


const [data, setData] = useState([])
let [task, setTask] = useState([])
let [temporaryTask, setTemporaryTask] = useState([])


const fetchData = () =>{
    fetch(googleSpreadTodolist)
    .then(res => res.json()
    )
    .then(
      (result) => {
       // setData(result.feed.entry.reverse())
        let dataFilter = result.values
       // console.log(dataFilter)
        let arrayTempWarning = []
        let arrayTempNumber = []
        let arrayTempNormal = []
        

if(dataFilter){
        for(let i=0; i<dataFilter.length;i++){
            const regexNumber = new RegExp('^[0-9]+', 'gm');
            const regexNormal = new RegExp('^[^0-9]+', 'gm');
            const regexWarning =new RegExp('^!+', 'gm');
            
            if(regexWarning.test(dataFilter[i][2])){
                const found = dataFilter[i][2].match(regexWarning);
                 const temp  = {filter:found[0].length};
                const fusion = Object.assign(temp, dataFilter[i],{type:"warning"});
                arrayTempWarning.push(fusion);
            }else if(regexNumber.test(dataFilter[i][2])){
                const found = dataFilter[i][2].match(regexNumber);
                 const temp  = {filter:parseInt(found)};
                const fusion = Object.assign(temp, dataFilter[i]);
                arrayTempNumber.push(fusion);

            }else{
                arrayTempNormal.push(dataFilter[i]);
            }

        }

      }
        function compare( a, b ) {
            if ( a.filter < b.filter ){
              return -1;
            }
            /*
            if ( a.filter > b.filter ){
              return 1;
            }
            return 0;
            */
          }
          function compareReverse( a, b ) {
            if ( a.filter > b.filter ){
              return -1;
            }
            /*
            if ( a.filter > b.filter ){
              return 1;
            }
            return 0;
            */
          }
        //console.log('____________warning___________________')
        
          
          
          arrayTempWarning.sort(compareReverse);
          //console.log(arrayTempWarning) 

            //console.log('_________________array normal______________')
           
            
            //console.log(arrayTempNormal)
            //console.log('_______________Number________________')
            arrayTempNumber.sort(compare);
         

            let fusionTableau = []
            if(arrayTempWarning || arrayTempNumber ||arrayTempNormal){
          for(let i=0; i<arrayTempWarning.length;i++){
          fusionTableau.push(arrayTempWarning[i])
        }
        for(let i=0; i<arrayTempNumber.length;i++){
            fusionTableau.push(arrayTempNumber[i])
          }
          for(let i=0; i<arrayTempNormal.length;i++){
            fusionTableau.push(arrayTempNormal[i])
          }
        }

        //console.log(fusionTableau)
        setData(fusionTableau)
        

       setTemporaryTask([])
        return
      },
      (error) => {
       setTemporaryTask([])
          setData('error')
      }
    )
}
 

useEffect(() => {
    fetchData()
  return ()=> setData([])
}, [])







let i=0



    return (
        <div id="toDoList">
        <h2>To do list</h2>

        {/*************************Add a new task***************************/}
        <form name="submit-to-google-sheet" onSubmit={(event) => {
            event.preventDefault()
            setTask('')
            setTemporaryTask(task)
          //  setTask("")
            const scriptURL = 'https://script.google.com/macros/s/AKfycbwPHOuEGC0sUVEaOceDz4HERlD9rqo6BsKtPdnD4x4RGeDMWnAvwKin/exec'
            
            
            const form = document.forms['submit-to-google-sheet']
            fetch(scriptURL, { method: 'POST', body: new FormData(form) })
                .then(response => {
                    if (response.status !== 200){
                        setTask([])
                        setTemporaryTask(false)
                        setTimeout(function(){ setTemporaryTask([]) }, 2000);

                      
                    }else{
                    fetchData()
                    setTask([])
                    setTemporaryTask(task)}
                    return
                    
                })
                .catch(error => {
                   setTask([])
                  setData('error')
                    return
                })}
            }
        >
            <input type="text" name="task" id="task" required value={task} onChange={(e)=>{setTask(e.target.value)}}/>
            <input type="text" name="checked" id="checked" readOnly value="no"/>
            <input type="text" name="removed" id="removed" readOnly value="no"/>
          <button action="" method="" type="submit"><span>+</span></button>
        </form>
        <ul>

      
        { temporaryTask.length>0 &&temporaryTask!==false ? 
         <li className="temporaryTask odd"><span>{temporaryTask}</span><span><img src={Loader} alt="loader" /></span></li>
        :temporaryTask===false? <li className="temporaryTask error odd"><span>Les tâches ne peut être ajoutée pour le moment.</span><span><img src={Warning} alt="loader" /></span></li>:""
       
        }
        {
            
            data === "error" ? <li>La liste de tâches ne peut être affichée pour le moment.</li> :
            data.length>0 ?
            
            data.filter(filtre => filtre[3].includes("no"))
            .map((item) => {
               
                i++
                
                return (

                    
                  


                    <li key={item[0]} className={(i%2>0 ?"odd" : "even")+(item.type==="warning" ?" warning" : "")}>
                        {/*************************Change checked status***************************/}                              
                        <form name={"checkedbutton"+item[0]} onSubmit={(event) => {
                        event.preventDefault()
                        
                        const scriptURL = 'https://script.google.com/macros/s/AKfycbwPHOuEGC0sUVEaOceDz4HERlD9rqo6BsKtPdnD4x4RGeDMWnAvwKin/exec'
                        const form = document.forms["checkedbutton"+item[0]]
                        fetch(scriptURL, { method: 'POST', body: new FormData(form) })
                            .then(response => {
                                //console.log("ok POST")
                               props.setRefresh(true)
                                
                            })
                            .catch(error => {
                              //  console.log("nok POST")
                            })}
                        }
                            
                        >
                            <input type="text" readOnly name="checked" value={item[0]}/>
                            
                            <button action="" method=""  type="submit" className={item[1]}
                             onClick={(event) => {

                                  

                                if(event.target.parentElement.classList.contains("yes")){
                                event.target.parentElement.classList.replace("yes","unchecked")
                                }else if(event.target.parentElement.classList.contains("no")){
                                 event.target.parentElement.classList.replace("no","checked")
                                }else if(event.target.parentElement.classList.contains("checked")){
                                    event.target.parentElement.classList.replace("checked","unchecked")
                                }else{event.target.parentElement.classList.replace("unchecked","checked")}



                             }}


                            
                            
                            ><span>{item[2]}</span></button>
                        </form>
                        {/*************************Change remove task***************************/}  
                        <form name={"removebutton"+item[0]} onSubmit={(event) => {
                        event.preventDefault()

                        const scriptURL = 'https://script.google.com/macros/s/AKfycbwPHOuEGC0sUVEaOceDz4HERlD9rqo6BsKtPdnD4x4RGeDMWnAvwKin/exec'
                        const form = document.forms["removebutton"+item[0]]
                        fetch(scriptURL, { method: 'POST', body: new FormData(form) })
                            .then(response => {
                                //console.log("ok POST")
                                
                            })
                            .catch(error => {
                                //console.log("nok POST")
                            })}
                        }>
                            <input type="text" name="removed" readOnly value={item[0]}/>
                            <button action="" method="" type="submit"
                            onClick={(event) => {
                                event.target.parentElement.parentElement.parentElement.classList.add("hidden")
                                setTimeout(function(){ 
                                    event.target.parentElement.parentElement.parentElement.classList.replace("hidden","displayNone")
                                }, 200);


                             }}
                            
                            
                            ><span>×</span></button>
                        </form>
                    </li>           
                        )
                            })
            
            
            
            
            
            
            : <li className="loader"><img src={Loader} alt="loader" /></li>
        }
        </ul>
    </div>
    )
}

